export default __webpack_public_path__ + "static/media/astronauts_hold_hand.e8ddcce0.png";